export default __webpack_public_path__ + "static/media/ImageNotAvailable.57c45eb0.png";